module.exports = __webpack_public_path__ + "static/media/retry-icon.60446976.svg";